/**
 * getAnalyticsReport uses `selected_attempt` as the attempt *id*
 * (e.g. { title: "Attempt 08", id: 7 } → selected_attempt: 7).
 * Never prefer title-number match over id — that maps 7 → "Attempt 07".
 */
export const resolveAttemptId = (selectedAttempt, attempts = []) => {
  if (selectedAttempt === undefined || selectedAttempt === null) {
    return undefined;
  }

  const value = Number(selectedAttempt);
  if (Number.isNaN(value)) return undefined;

  if (!Array.isArray(attempts) || !attempts.length) {
    return value;
  }

  const byId = attempts.find((item) => Number(item?.id) === value);
  if (byId) return Number(byId.id);

  const byTitle = attempts.find(
    (item) => Number(String(item?.title || "").match(/\d+/)?.[0]) === value
  );
  if (byTitle) return Number(byTitle.id);

  const byIndex = attempts[value - 1];
  if (byIndex) return Number(byIndex.id);

  return value;
};

export const getLatestAttemptId = (attempts = []) => {
  if (!Array.isArray(attempts) || !attempts.length) return undefined;

  return attempts.reduce((best, item) => {
    const currentCount = Number(
      String(item?.title || "").match(/\d+/)?.[0] || 0
    );
    const bestCount = Number(String(best?.title || "").match(/\d+/)?.[0] || 0);
    if (currentCount > bestCount) return item;
    if (currentCount === bestCount && Number(item?.id) > Number(best?.id)) {
      return item;
    }
    return best;
  }, attempts[0])?.id;
};
